import { entryWeight, registerDrivers, type RegisterEntry } from '@/lib/registerRiskScore';

/** One risk, issue or assumption from a project's documents, whether already in the register or just read. */
export type RegisterRow = RegisterEntry & {
  project_id: string;
  ref: string | null;
  title: string;
  owner: string | null;
  mitigation: string | null;
  updated_at: string | null;
};

export const today = () => new Date().toISOString().slice(0, 10);

export const severityOf = (r: RegisterRow): 'critical' | 'high' | 'medium' | 'low' => {
  if (r.entry_type === 'issue') return (r.severity?.match(/\b(critical|high|medium|low)\b/i)?.[1].toLowerCase() as 'critical' | 'high' | 'medium' | 'low') ?? 'low';
  if (r.rating === 'high') return (r.score ?? 0) >= 20 ? 'critical' : 'high';
  return r.rating === 'medium' ? 'medium' : 'low';
};

/** Open risks and issues, heaviest first. */
export function topEntries(rows: RegisterRow[], limit?: number): RegisterRow[] {
  const day = today();
  const open = rows.filter((r) => entryWeight(r, day) > 0).sort((a, b) => entryWeight(b, day) - entryWeight(a, day) || a.title.localeCompare(b.title));
  return limit ? open.slice(0, limit) : open;
}

export function registerSummary(rows: RegisterRow[]) {
  const d = registerDrivers(rows, today());
  const latest = rows.reduce<string | null>((m, r) => (r.updated_at && (!m || r.updated_at > m) ? r.updated_at : m), null);
  return { ...d, latest, bySeverity: topEntries(rows).reduce((acc, r) => { acc[severityOf(r)]++; return acc; }, { critical: 0, high: 0, medium: 0, low: 0 }) };
}

